<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="mb-4">Blogs</h1>
      </v-col>
    </v-row>
    <div class="d-none d-sm-flex flex-wrap justify-center">
      <v-btn
        class="button-styles"
        :color="type==='All' ? 'primary' : 'secondary'"
        rounded
        @click="clickEvent('All')"
      >All</v-btn>
      <v-btn
        class="button-styles"
        :color="type==='Cloud' ? 'primary' : 'secondary'"
        rounded
        @click="clickEvent('Cloud')"
      >Cloud</v-btn>
      <v-btn
        class="button-styles"
        :color="type==='Professional' ? 'primary' : 'secondary'"
        rounded
        @click="clickEvent('Professional')"
      >Professional</v-btn>
      <v-btn
        class="button-styles"
        :color="type==='Productivity' ? 'primary' : 'secondary'"
        rounded
        @click="clickEvent('Productivity')"
      >Productivity</v-btn>
    </div>
    <div class="d-flex d-sm-none flex-column justify-center">
      <v-select
        :items="items"
        filled
        label="Select category"
        dense
        solo
        v-model="type"
        @change="clickEvent(type)"
      ></v-select>
      <!-- <p class="mb-0">This is the type: {{ type }}</p> -->
    </div>
    <v-row>
      <v-col
        v-for="(item, index) in blogDataLocal"
        :key="index"
        cols="12"
        md="6"
        lg="4"
        class="d-flex justify-center"
      >
        <BlogCard
          :title="item.title"
          :date="item.date"
          :image="item.image"
          :url="item.url"
          :attribute="item.attribute"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BlogCard from "@/components/sub-components/BlogCard.vue";
import blogData from "@/store/blogsData.js";
// import { mapState, mapActions } from "vuex";

export default {
  name: "Blogs",
  components: {
    BlogCard
  },
  data: () => ({
    blogs: [],
    blogDataLocal: [],
    type: "",
    items: ["All", "Cloud", "Professional", "Productivity"]
  }),
  methods: {
    clickEvent(event) {
      this.type = event;
      this.blogDataLocal = [];
      if (event != "All") {
        blogData.map(item => {
          if (item.attribute === event) {
            this.blogDataLocal.push(item);
          }
        });
      } else this.blogDataLocal = blogData;
    }
  },
  mounted() {
    this.blogDataLocal = blogData;
    this.type = "All";
  }
};
</script>

<style>
</style>